import React, { useState, useEffect } from "react";
import "./RotateSc.css";
import rotateImg from "../Assets/Images/Brochure/rotate.gif";
import Brochure from "./Brocher";
import Book from "./Book/Book";

const RotateSc = () => {
  const [isPortrait, setIsPortrait] = useState(true);

  const handleOrientationChange = () => {
    setIsPortrait(window.innerHeight >= window.innerWidth);
  };

  useEffect(() => {
    handleOrientationChange();
    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  return (
    <div className={`rotate-container ${isPortrait ? "portrait" : "landscape"}`}>
      <div className="rotate-content">
        {isPortrait ? (
          <div className="rotate-message">
            <img src={rotateImg} alt="rotate" className="rotate-icon" />
          </div>
        ) : (
          <div>{<Book />}</div>
        )}
      </div>
    </div>
  );
};

export default RotateSc;
